<script>
    import { onMount } from "svelte";
    import * as api from "../stores/auth.store";
    import * as Common from "../utiles/common.util";

    onMount(() => {
        // 로그인 상태 체크
        api.apiGetStatus();
    });

    // async function logout() {
    //     await api.apiGetLogout();
    // }
</script>

<header>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <img
        src="resource/img/logo.png"
        alt=""
        class="logo-hd"
        on:click={() => {
            Common.goPage("#/");
        }}
    />
</header>
